import { AddToCartModal } from './add-to-cart-modal'

export default AddToCartModal
